import { Flavour } from "./Flavour";
import { Restaurant } from "./Restaurant";
import {MenuItemVariantGroup} from "./MenuItemVariantGroup";
import {MenuCategory} from "./MenuCategory";

export class MenuItem {

    private _id: number;
    private _name: string;
    private _description: string;
    private _is_available: boolean;
    private _restaurant_id: number;
    private _flavours: Flavour[];
    private _image_url: string;
    private _available_from: string | null;
    private _available_till: string | null;
    private _restaurant: Restaurant;
    private _variant_groups: MenuItemVariantGroup[];
    private _selected_variant_group_ids: number[];
    private _category: MenuCategory | null;
    private _category_id: number | null;

    constructor() {
        this._id = 0;
        this._name = "";
        this._description = "";
        this._is_available = true;
        this._restaurant_id = 0;
        this._flavours = [];
        this._image_url = "";
        this._available_till = null;
        this._available_from = null;
        this._restaurant = new Restaurant();
        this._variant_groups = [];
        this._selected_variant_group_ids = [];
        this._category = null;
        this._category_id = null;
    }


    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get description(): string {
        return this._description;
    }

    set description(value: string) {
        this._description = value;
    }

    get is_available(): boolean {
        return this._is_available;
    }

    set is_available(value: boolean) {
        this._is_available = value;
    }

    get restaurant_id(): number {
        return this._restaurant_id;
    }

    set restaurant_id(value: number) {
        this._restaurant_id = value;
    }

    get flavours(): Flavour[] {
        return this._flavours;
    }

    set flavours(value: Flavour[]) {
        this._flavours = value;
    }

    get image_url(): string {
        return this._image_url;
    }

    set image_url(value: string) {
        this._image_url = value;
    }

    get available_from(): string | null {
        return this._available_from;
    }

    set available_from(value: string | null) {
        this._available_from = value;
    }

    get available_till(): string | null {
        return this._available_till;
    }

    set available_till(value: string | null) {
        this._available_till = value;
    }

    get restaurant(): Restaurant {
        return this._restaurant;
    }

    set restaurant(value: Restaurant) {
        this._restaurant = value;
    }

    get variant_groups(): MenuItemVariantGroup[] {
        return this._variant_groups;
    }

    set variant_groups(value: MenuItemVariantGroup[]) {
        this._variant_groups = value;
    }

    get selected_variant_group_ids(): number[] {
        return this._selected_variant_group_ids;
    }

    set selected_variant_group_ids(value: number[]) {
        this._selected_variant_group_ids = value;
    }

    get category(): MenuCategory | null {
        return this._category;
    }

    set category(value: MenuCategory | null) {
        this._category = value;
    }

    get category_id(): number | null {
        return this._category_id;
    }

    set category_id(value: number | null) {
        this._category_id = value;
    }
}